$(function(){

	//traitement d'une requete article
	var article = getQuery('article')
	if(article){
		showArticle(article)
	}
	
	$(document).on('click','.rubrique-bouton',function(){
		$('.rubrique-bouton').removeClass('activated');
		$(this).addClass('activated');
		$('.rubrique,.archives').hide();
		$('#'+$(this).attr('rel')).show();
	});	
	
	$('.rubrique-bouton > img').hover(function(){
		if($(this).parent().hasClass('activated'))
			$('.archives.'+$(this).parent().attr('rel')).show();
	},function(e){
	});
	
	$('.rubrique-bouton').hover(function(){
	},function(e){
		$('.archives').hide();
	});
	
	$('.archives .item').click(function(){
		showArticle($(this).attr('rel'))
	});
});

function showArticle(aid){
	$('.archives').hide();
	$.getJSON('../contents/php/JSON_table.php?s=* FROM actualite WHERE id_actualite='+aid,function(d){
		var article=d[0];
		var rubrique= (article.genre=='C') ? '#rapports' : '#temoignages';
		var rawRubrique = rubrique.replace('#','');
		var auteur = (article.genre=='C') ? 'Jean-Pierre Morel' : article.auteur;
		$('.titre2',rubrique).html(article.small_titre);
		$('.date',rubrique).html(dateFromDB(article.ladate));
		$('.auteur',rubrique).html(auteur);
		$('.texte',rubrique).html(article.texte);
		$('.rubrique-bouton[rel="'+rubrique.replace('#','')+'"]').click();
		if(id=='')
			$('.texte a',rubrique).not('.ok').each(function() { $(this).attr('href', 'javascript:getLogged();').removeAttr('target');});
	});
}

function dateFromDB(string){
	var D=string.split("-");
	return D[2] + "/" + D[1] + "/" + D[0];
}

function getLogged(){
	alert("Ces informations sont réservées aux parrains de l'Association. \n\nConnectez vous depuis l'Espace Parrains !");
}

function getQuery(n) {
    var half = location.search.split(n + '=')[1];
    return half !== undefined ? decodeURIComponent(half.split('&')[0]) : null;
}
